import { NgModule } from '@angular/core';
import { CommonModule }  from '@angular/common';
import { HttpModule } from '@angular/http';
import { MdlModule } from '@angular-mdl/core';
import { TranslateModule } from '../../../translate/translate.module';

import { CopyrightFooterComponent } from './copyright-footer.component';

@NgModule({
  imports: [
    CommonModule,
    MdlModule,
    HttpModule,
    TranslateModule
  ],
  declarations: [
    CopyrightFooterComponent
  ],
  exports: [CopyrightFooterComponent]
})
export class CopyrightFooterModule { }